import { PropsWithChildren } from "react";
import { useReport } from "./context";
import { TransitionModal } from "components/modal";
import { Box } from "@mui/material";

const TALLY_FORM_URL =
  "https://tally.so/embed/xXAlJv?alignLeft=1&hideTitle=1&transparentBackground=1";

export function ReportModal({ children }: PropsWithChildren) {
  const { modalIsOpen, toggleModal } = useReport();
  return (
    <>
      <TransitionModal open={modalIsOpen} onClose={toggleModal}>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            width: "100%",
            pt: 8,
            px: { xs: 2, sm: 4, md: 6 },
            pb: { xs: 2, sm: 4 },
          }}
        >
          <Box
            component="iframe"
            src={TALLY_FORM_URL}
            title="Faire un retour"
            sx={{
              flex: 1,
              width: "100%",
              height: "100%",
              border: 0,
              borderRadius: 3,
              display: "block",
            }}
          />
        </Box>
      </TransitionModal>
      {children}
    </>
  );
}
